import React, { useState, useEffect } from 'react';
import './Hero.css';
import OrderNowButton from './OrderNowButton';
import explore0 from '../assets/home/carousel/0.jpg';
import explore1 from '../assets/home/carousel/1.jpg';
import explore2 from '../assets/home/carousel/2.jpg';
import explore3 from '../assets/home/carousel/3.jpg';
import explore4 from '../assets/home/carousel/4.jpg';
import explore5 from '../assets/home/carousel/5.jpg';
import explore6 from '../assets/home/carousel/6.jpg';
import explore7 from '../assets/home/carousel/7.jpg';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  
  const slides = [
    { id: 1, image: explore0 },
    { id: 2, image: explore1 },
    { id: 3, image: explore2 },
    { id: 4, image: explore3 },
    { id: 5, image: explore4 },
    { id: 6, image: explore5 },
    { id: 7, image: explore6 },
    { id: 8, image: explore7 }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setIsTransitioning(true);
      setCurrentSlide((prev) => (prev + 1) % slides.length);
      setTimeout(() => setIsTransitioning(false), 50);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img src={slide.image} alt={`Food presentation ${index + 1}`} />
          </div>
        ))}
      </div>
      <div className="hero-content">
        <div className="hero-text">
          <span className="hero-subtitle">Welcome to Drake's</span>
          <h1 className="hero-title">Where Good Living Begins</h1>
          <div className="hero-buttons">
            <OrderNowButton theme="light" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 